import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SelectFileComponent} from './select-file.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [SelectFileComponent],
  exports: [SelectFileComponent]
})
export class SelectFileModule {
}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/shared/select-file/select-file.module.ts